import { Paper, Text } from "@mantine/core";
import React from "react";

/**
 * Shown in place of the count banner/results table whenever the criteria chip list is empty
 * (FS_05_Reporting_01 — Resolved Decisions: an empty filter is a no-op, not "match everyone").
 * Fixed copy, not per-report-configurable — both report pages show exactly this.
 */
export const ReportEmptyState: React.FC = () => {
  return (
    <Paper withBorder radius="md" p="xl" style={{ borderStyle: "dashed", textAlign: "center" }}>
      <Text size="lg" fw={500}>
        Choose a filter to start.
      </Text>
      <Text size="sm" c="dimmed" mt="xs">
        Need a report for all persons? Contact the Daisy team about adding a dedicated report type.
      </Text>
    </Paper>
  );
};
